import cn from 'classnames';
import styles from './styles.module.sass';
import React from 'react';
import cubeHorizontalStyles from './cube-horizontal.module.sass';

interface IndividualBanner {
    key: string; // Unique key for each banner.
    content: string; // HTML string content for the banner.
}

interface BannerProps {
    customStyle?: React.CSSProperties; // Optional custom styles for the banner.
    banners: IndividualBanner[]; // Array of banners.
    isVerticalLayout?: boolean;
    withCubeAnimation?: boolean;
}

const bannerWithCubeAnimation = (banners: IndividualBanner[]) => {
    if (!banners.length) return null;

    return (
        // wrapper-with-bottom-padding class is to ensure there is space between this component and the next one
        // below it. Padding is used instead of margin to avoid unnecessary shift caused by `react-virtual` when using
        // margin.
        <div className={cubeHorizontalStyles['wrapper-with-bottom-padding']}>
            <div className={cubeHorizontalStyles.wrapper}>
                <div className={cubeHorizontalStyles.cube} style={{ height: '100px' }}>
                    {['front', 'top', 'bottom', 'back'].map((side, i) => {
                        const content = banners[i % banners.length].content;

                        return (
                            <div key={side} className={cubeHorizontalStyles[side]}>
                                <div dangerouslySetInnerHTML={{ __html: content }} />
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export const Banner = ({ banners, customStyle = {}, isVerticalLayout, withCubeAnimation }: BannerProps) => {
    if (withCubeAnimation && banners.length > 1) return bannerWithCubeAnimation(banners);

    // Render each banner using `dangerouslySetInnerHTML`.
    const content = banners.map((banner) => (
        <div
            className={styles['discount-content']}
            key={banner.key}
            dangerouslySetInnerHTML={{ __html: banner.content }}
            style={customStyle}
        />
    ));

    // If there's more than one banner, wrap them in a container. Otherwise, just render the content.
    return banners.length > 1 ? (
        <div className={cn(styles['discount-holder'], isVerticalLayout && styles.vertical)}>{content}</div>
    ) : (
        content
    );
};
